export const START_EDIT_QUOTE = 'START_EDIT_QUOTE';
export const CUSTOM_SUBMIT_QUOTE = 'CUSTOM_SUBMIT_QUOTE';
